export default (newsUid) => {
    return useFetchWithTanstackQuery({
        queryKey: ['newsDetail', newsUid],
        queryFn: () => $fetch(`/api/center/news/${newsUid}`),
        options: {
            staleTime: 5 * 60 * 1000 // 5 min
        }
    })
}
